var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CandidateLayout',{attrs:{"tab":"General","candidate":_vm.candidate,"applies":_vm.applies,"apply":_vm.apply,"recruiter_id":_vm.recruiter_id,"skills":_vm.skills,"other_avatar":_vm.other_avatar}})
}
var staticRenderFns = []

export { render, staticRenderFns }